import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "settings-assets-container w-100" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "mb-5" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "title" }, "Assets Manager"),
  /*#__PURE__*/_createElementVNode("p", { class: "mb-0 sub-title" }, [
    /*#__PURE__*/_createElementVNode("small", null, "Manage the application assets")
  ])
], -1)
const _hoisted_3 = { class: "card card-flush mb-10" }
const _hoisted_4 = { class: "card-header pt-8" }
const _hoisted_5 = { class: "card-title" }
const _hoisted_6 = { class: "d-flex align-items-center position-relative my-1" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-1 position-absolute ms-6" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("rect", {
      opacity: "0.5",
      x: "17.0365",
      y: "15.1223",
      width: "8.15546",
      height: "2",
      rx: "1",
      transform: "rotate(45 17.0365 15.1223)",
      fill: "currentColor"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M11 19C6.55556 19 3 15.4444 3 11C3 6.55556 6.55556 3 11 3C15.4444 3 19 6.55556 19 11C19 15.4444 15.4444 19 11 19ZM11 5C7.53333 5 5 7.53333 5 11C5 14.4667 7.53333 17 11 17C14.4667 17 17 14.4667 17 11C17 7.53333 14.4667 5 11 5Z",
      fill: "currentColor"
    })
  ])
], -1)
const _hoisted_8 = { class: "card-toolbar" }
const _hoisted_9 = {
  class: "d-flex justify-content-end",
  "data-kt-filemanager-table-toolbar": "base"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-folder-plus text-primary fa-2x" }, null, -1)
const _hoisted_11 = /*#__PURE__*/_createTextVNode("New Folder ")
const _hoisted_12 = [
  _hoisted_10,
  _hoisted_11
]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-cloud-upload-alt text-white" }, null, -1)
const _hoisted_14 = /*#__PURE__*/_createTextVNode("Upload Files ")
const _hoisted_15 = [
  _hoisted_13,
  _hoisted_14
]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", {
  class: "d-flex justify-content-end align-items-center d-none",
  "data-kt-filemanager-table-toolbar": "selected"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "fw-bold me-5" }, [
    /*#__PURE__*/_createElementVNode("span", {
      class: "me-2",
      "data-kt-filemanager-table-select": "selected_count"
    }),
    /*#__PURE__*/_createTextVNode("Selected ")
  ]),
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn btn-danger",
    "data-kt-filemanager-table-select": "delete_selected"
  }, " Delete Selected ")
], -1)
const _hoisted_17 = {
  key: 0,
  class: "card-body"
}
const _hoisted_18 = { class: "d-flex flex-stack" }
const _hoisted_19 = {
  key: 1,
  class: "p-5 mt-5"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Navigator = _resolveComponent("Navigator")!
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_el_skeleton = _resolveComponent("el-skeleton")!
  const _component_UploadModal = _resolveComponent("UploadModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Navigator, {
      to: "/settings",
      text: "Back to settings"
    }),
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "data-kt-filemanager-table-filter": "search",
              class: "form-control form-control-solid w-250px ps-15",
              placeholder: "Search Folders",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchValue) = $event))
            }, null, 512), [
              [_vModelText, _ctx.searchValue]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-new-design-secondary me-3",
              id: "kt_file_manager_new_folder",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.adding_folder = true))
            }, _hoisted_12),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-new-design-primary",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.uploading = true))
            }, _hoisted_15)
          ]),
          _hoisted_16
        ])
      ]),
      (!_ctx.tableLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _createVNode(_component_Breadcrumb, {
                onOnSelectCrumb: _ctx.handleSelectCrumb,
                items: _ctx.formattedCrumbs
              }, null, 8, ["onOnSelectCrumb", "items"])
            ]),
            _createVNode(_component_router_view, {
              newFolderName: _ctx.newFolderName,
              folders: _ctx.filteredDirContents,
              tableLoading: _ctx.tableLoading,
              adding_folder: _ctx.adding_folder,
              onAddingFolder: _ctx.addFolder,
              onSaveFolder: _ctx.handleSaveFolder,
              onOnSelect: _ctx.onSelect,
              onOnDeleteFolder: _ctx.handleDeleteFolder,
              onOnViewFile: _ctx.handleOnViewFile,
              onOnDeleteFile: _ctx.handleDeleteFile
            }, null, 8, ["newFolderName", "folders", "tableLoading", "adding_folder", "onAddingFolder", "onSaveFolder", "onOnSelect", "onOnDeleteFolder", "onOnViewFile", "onOnDeleteFile"])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_19, [
            _createVNode(_component_el_skeleton, {
              rows: 10,
              animated: "true"
            })
          ]))
    ]),
    _createVNode(_component_UploadModal, {
      modelValue: _ctx.uploading,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.uploading) = $event)),
      loadState: _ctx.loadingUpload,
      onAddUploadFile: _ctx.handleAddUploadFile,
      onRemoveUploadFile: _ctx.handleRemoveSupportDocument,
      onUploadFiles: _ctx.handleUploadFiles
    }, null, 8, ["modelValue", "loadState", "onAddUploadFile", "onRemoveUploadFile", "onUploadFiles"])
  ]))
}